import { useState } from "react";
import { QrCode } from "lucide-react";
import { BankInQrModal } from "./BankInQrModal";

export function BankInQrButton({
  imageUrl,
  className = "",
}: {
  imageUrl: string;
  className?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-1.5 rounded-xl border border-brand-pink/40 bg-brand-pink/10 px-3 py-2 text-xs font-semibold text-brand-pink transition-colors hover:bg-brand-pink/15 ${className}`}
      >
        <QrCode size={16} strokeWidth={2} />
        View QR code
      </button>
      <BankInQrModal open={open} imageUrl={imageUrl} onClose={() => setOpen(false)} />
    </>
  );
}
